import { Component, Input, ChangeDetectionStrategy } from "@angular/core";

@Component({
    selector: "app-deploy-tiles",
    templateUrl: "./deploy-tiles.component.html",
    styleUrls: ["./deploy-tiles.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DeployTilesComponent {
  @Input() icon: string = "fa fa-check";
  @Input() iconType: "image" | "fontawesome" = "fontawesome";
  @Input() title: string = "Title";
  @Input() state: "pending" | "executing" | "completed" = "pending";
  @Input() statusText: string = "Status";
  @Input() progress: number = 20;
  @Input() tileWidth: "normal" | "wide" = "normal";

  getStatusStyles() {
    if (this.state === "completed") {
      return {
        iconBg: "#D1FAE5",
        iconColor: "#02D298",
      };
    } else {
      return {
        iconBg: "#EEEEEE",
        iconColor: "#4B5563",
      };
    }
  }
}
